// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__qapDE","info":"UpdateTermsInfo_info__LxiH-"};